/**************************************************
 * Nombre:       Seccion_Despachos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import React, {useContext} from "react";
import Inicio_Portada_Bienvenida from "./Componentes/Inicio_Portada_Bienvenida";
import Inicio_Capacitaciones_Disponibles from "./Componentes/Inicio_Capacitaciones_Disponibles";
import Calendario_Calendario from "./Componentes/Calendario_Calendario";
import {usuarioContext} from "../../App";


const Seccion_Inicio = () => {
    const cData = useContext(usuarioContext)


    return (

        <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'center'}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{marginTop: 2.5, maxWidth: '1200px', pb: 6}}
                spacing={4}
            >


                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                    <Inicio_Portada_Bienvenida/>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start', mt: 4}}>
                    <Inicio_Capacitaciones_Disponibles/>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Calendario_Calendario/>
                </Grid>


            </Grid>

        </Grid>
    )

}
export default Seccion_Inicio

